import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import account from './modules/account'
import user from './modules/user'
import role from './modules/role'
import tenant from './modules/tenant'
import warehouseCity from './modules/warehouse-city'
import warehouseInfo from './modules/warehouseInfo'
import fontorder from './modules/font-order'
import fontmainlandorder from './modules/font-mainlandorder'
import backorder from './modules/back-order'
import backmainlandorder from './modules/back-mainlandorder'
import backlogistics from './modules/back-logistics'
import fontamount from './modules/font-amount'
import backflows from './modules/back-flow'
import expressimport from './modules/express-import'
import expressuserinfo from './modules/font-userexpressinfo'
import warehouseInfoDetail from './modules/warehouseinfodetail'
import expressrejectioninfo from './modules/list-expressrejection'
import returnrejection from './modules/back-returnrejection'
import mainlandfeightinfo from './modules/mainland-freight'
import frontmainlandfeightinfo from './modules/front-mainlandfreight'
import authorizationShop from './modules/authorization'
import orderreturn from './modules/back-shopeeorderreturn'
import abnormalreceivingorder from './modules/back-alnormalreceivingorder'
import frontabnormalreceivingorder from './modules/front-abnormalreceivingorder'
import frontorderreturn from './modules/front-shopeeorderreturn'
import packstatistical from './modules/back-packstatistical'
import backSignforLogisticsStatistical from './modules/back-signfor-logistics-statistical'
import flowAmountStatistical from './modules/back-amount-flow-statistical'
import fontflowAmountStatistical from './modules/font-amount-flow-statistical'
import backSignlogistics from './modules/back-sign-logistics'
import basecostsetting from './modules/basecost-setting'
import mainlandpackage from './modules/mainland-package'
import courierExpressDelivery from './modules/courier-express-delivery'
import couriercompany from './modules/back-couriercompany'
import thirdpartyparameter from './modules/thirdpartyparameter'
import backintologistics from './modules/back-intologisticsrecord'
import backstoreaddress from './modules/back-storeaddress'
import frontstock from './modules/front-stock'
import backstock from './modules/back-stock'
import frontstockproduct from './modules/front-stockproduct'
import backstockproduct from './modules/back-stockproduct'
import backlistedhistory from './modules/back-listedhistory'
import skumapping from './modules/skumapping'
import overseasbasecostsetting from './modules/overseas-basecostsetting'
import frontstockorder from './modules/front-stockorder'
import frontlistedhistory from './modules/front-listedhistory'
import frontthirdparty from './modules/front-thirdparty'
import inoutstockrecord from './modules/inoutstockrecord'
import backstockorder from './modules/back-stockorder'
import frontabroadorder from './modules/front-abroadorder'
import backabroadorder from './modules/back-abroadorder'
import backabroadlogistics from './modules/back-abroadlogistics'
import fontstockreturnorder from './modules/font-stockreturnorder'
import fontoverseasreturnorders from './modules/font-overseasreturnorder'
import intoabroadstockreturncheck from './modules/into-abroadstockreturn-check'
import backoverseasreturnorder from './modules/back-overseasreturnorder'
import backstockreturnorder from './modules/back-stockreturnorder'
import backoverseasreturnhandle from './modules/back-overseasreturnhandle'
import group from './modules/group'
import backrefusal from './modules/back-refusalorder'
import backadvance from './modules/back-advanceorder'
import backynrefusal from './modules/back-ynrefusalorder'
import fronturgentorder from './modules/font-urgentorder'
import backurgentorder from './modules/back-urgentorder'
import backuserstorageconfigSetting from './modules/back-userstorageconfig'
import orderoperate from './modules/order-operate'
import publicstockproduct from './modules/back-public-stockproduct'
import backStockAgeRules from './modules/back-stock-age-rule'
import backStockAgeRecord from './modules/back-stock-age-record'
import frontStockAgeRecord from './modules/front-stock-age-record'
import frontpreplan from './modules/front-pre-plan'
import frontPackingBatch from './modules/front-pack-manage'
import backpreplan from './modules/back-pre-plan'
import backPackingBatch from './modules/back-pack-manage'
import backStockOrderBatch from './modules/back-stock-order-batch'
import frontIntologistics from './modules/front-intologisticsrecord'


const store = new Vuex.Store({
    state: {
        //
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        account,
        user,
        role,
        tenant,
        warehouseCity,
        warehouseInfo,
        fontorder,
        backorder,
        backlogistics,
        fontamount,
        backflows,
        expressimport,
        expressuserinfo,
        warehouseInfoDetail,
        expressrejectioninfo,
        returnrejection,
        mainlandfeightinfo,
        frontmainlandfeightinfo,
        fontmainlandorder,
        backmainlandorder,
        authorizationShop,
        orderreturn,
        abnormalreceivingorder,
        frontabnormalreceivingorder,
        frontorderreturn,
        packstatistical,
        backSignforLogisticsStatistical,
        flowAmountStatistical,
        fontflowAmountStatistical,
        backSignlogistics,
        basecostsetting,
        mainlandpackage,
        courierExpressDelivery,
        couriercompany,
        thirdpartyparameter,
        backintologistics,
        backstoreaddress,
        frontstock,
        backstock,
        frontstockproduct,
        backstockproduct,
        backlistedhistory,
        skumapping,
        overseasbasecostsetting,
        frontstockorder,
        frontlistedhistory,
        frontthirdparty,
        backstockorder,
        inoutstockrecord,
        frontabroadorder,
        backabroadorder,
        backabroadlogistics,
        fontstockreturnorder,
        fontoverseasreturnorders,
        intoabroadstockreturncheck,
        backoverseasreturnorder,
        backstockreturnorder,
        backoverseasreturnhandle,
        group,
        backrefusal,
        backadvance,
        backynrefusal,
        fronturgentorder,
        backurgentorder,
        backuserstorageconfigSetting,
        orderoperate,
        publicstockproduct,
        backStockAgeRules,
        backStockAgeRecord,
        frontStockAgeRecord,
        frontpreplan,
        frontPackingBatch,
        backpreplan,
        backPackingBatch,
        backStockOrderBatch,
        frontIntologistics
    }
});

export default store;